import * as React from 'react';

import './paypal-detail.scss';

interface PaypalDetailProps {
  paypalAccountEmail: string;
}

const PaypalDetail = (props: PaypalDetailProps) => {
  const { paypalAccountEmail } = props;

  return (
    <div className={'paypal-payment-info'}>
      <strong className={'paypal-payment-method'}>PayPal account</strong>
      <span className={'paypal-payment-email'}>{paypalAccountEmail}</span>
    </div>
  );
};

export default PaypalDetail;
